/**
 * Created by eladd on 7/17/2017.
 */
import {
	ChangeDetectorRef,
	Component,
	ElementRef,
	EventEmitter, HostBinding,
	HostListener,
	Input,
	NgZone,
	Output,
	ViewChild
} from "@angular/core";
import {DeltaEvent} from "../../../directives/touch.drag/delta.drag.directive";
import {PopupPositionStore} from "./popup.position.store";
import {WindowEvent, WindowHostListenerService} from "../../../../window/window.host.listener.service";
import {RtlService} from "../../../../rtl/services/rtl.service";
import { Subscription } from "rxjs";

export const PX = 'px';
const TITLE_HEIGHT_PX = 40;
const BORDER_PX = 4;
export const MIN_PERCENT_GAP= 0.01;
export const MIN_PX_GAP= 10;

export type POSITION_TOKEN =string;
@Component({ template: '' })
export abstract class AbstractPopupComponent {
	@Input() protected show: boolean;
	@Input() protected disposable = true;
	@Input() protected positionToken:string;

	@Output() close = new EventEmitter();
	@Output() developerOptionsClick = new EventEmitter();

	@ViewChild('content',{static:false}) content: ElementRef;
	contentInit: boolean;

	@ViewChild('audio',{static:false}) audio: ElementRef<HTMLAudioElement>;

	public keepContentsOnDOM; // this is a possible input only for the non-modal popup

	public isModal:boolean; // this should have been a constructor parameter but since it's an angular
							// component we cannot
	public strongVisibility:boolean;
	//private resizeSubscription:Subscription;
	
	protected abstract clearWindowEventSubscription():void;;
	protected windowEventSubscription:Subscription;

	public rtlStr:string;
	constructor(protected ngZone: NgZone,protected cd: ChangeDetectorRef,
				protected positionStore:PopupPositionStore,
				protected el:ElementRef,
				protected  windowsEventsListener:WindowHostListenerService,
				protected rtl:RtlService) {

		// untilDestoy doesnt work here. probably because of the component inheritance
		this.windowEventSubscription= this.windowsEventsListener.getObservable(WindowEvent.resize).subscribe(x=>{
			this.cd.detectChanges();//trigger the positioning validation
		});
		this.rtlStr=this.rtl.isRtl()?'rtl':'ltr';
	}

	protected checkHeight(callback: (height:string,width:string) => void){
		this.ngZone.runOutsideAngular(() => {
			setTimeout(() => {
					callback( this.calcContentHeight() + PX,this.calcContentWidth()+PX);
					this.cd.detectChanges();
				})
			});
	}

	calcContentHeight() {
		return this.content.nativeElement.scrollHeight + TITLE_HEIGHT_PX + BORDER_PX;
	}

	calcContentWidth() {
		return this.content.nativeElement.scrollWidth + TITLE_HEIGHT_PX + BORDER_PX;
	}

	ngAfterContentInit() {
		this.contentInit = true;
	}

	protected normalizeNew(contentInPercent,total,lastDelta,currDelta):{normalizedTotal:string, normalizedDelta:number}{
		//a max of 98% of the screen is applied in css on the popup content
		contentInPercent = Math.min(contentInPercent,98);
		let actualDelta=lastDelta + currDelta;
		let fullSize=contentInPercent/100*total;
		let halfSize= (contentInPercent/100)*total/2;
		let baseSpaceFrom=(total/2 - halfSize);
		let newSupposedToBePos=baseSpaceFrom+actualDelta;
		let minGapPx=Math.min(MIN_PERCENT_GAP*total,MIN_PX_GAP);
		let newDeltaInPx;
		if (newSupposedToBePos+fullSize>total-minGapPx*2){
			if (currDelta>0){
				newDeltaInPx=total/2-halfSize-minGapPx-lastDelta;
			}else {
				newDeltaInPx=currDelta;
			}
			newSupposedToBePos=total-fullSize-minGapPx;
		}else if (currDelta<0 && (newSupposedToBePos < minGapPx)){
			newDeltaInPx=-lastDelta-baseSpaceFrom;
			newSupposedToBePos=minGapPx;
		}else{
			newDeltaInPx=currDelta;
			if (newSupposedToBePos < minGapPx){
				newSupposedToBePos=minGapPx;
			}
		}
		return  {normalizedTotal:newSupposedToBePos,normalizedDelta:newDeltaInPx};
	}

	public overrideTouchMove($event){
		if (this.show===false){
			return true;
		}else{
			$event.preventDefault();
			return false;
		}
	}

	public get hidden() {
		return this.show === false;
	}

	@HostBinding('class.is-modaless') get isModalClass(){
		return !this.isModal;
	}

	@HostListener('click', ['$event'])
	public onHostClick($event) {
		if (this.disposable && $event.target.tagName.toLowerCase().endsWith('-popup')) {
			$event.stopPropagation();
			this.onClose();
		}else if (this.isModal){
			if (event.target===this.el.nativeElement){
				this.audio?.nativeElement.play();
				this.strongVisibility=true;
				setTimeout(()=>{
					this.strongVisibility=false;
					this.cd.markForCheck();
				},0.6*1000);
			}
		}
	}

	public abstract headerDeltaDrag(event: DeltaEvent);

	public onClose() {
		this.close.emit(null);
	}

	public onLabelClick(event) {
		if (event.ctrlKey && event.shiftKey) {
			this.developerOptionsClick.emit(true);
		}
	}


	// to be overriden by non-modal popups. this isnt very nice OO wise but it gives us the cleanest option to
	// reuse the same template for all different popups
	public  get Top(){
		return undefined;
	}
	public get Left(){
		return undefined;
	}
	public get Height() {
		return undefined;
	}
	public get Width(){
		return undefined;
	}

	protected removePX(a:string){
		return +(a.substring(0,a.indexOf(PX)));
	}
}
